import { AppIcon } from '@/components/ui/app-icon';
import { useState } from 'react';

import { iconDesktop } from '@/lib/icons';
import { BRAND } from '@/lib/brand';
import { TOUCH_ONLY_QUERY } from '@/lib/touch-only';

/**
 * Said before the account exists, on a phone or plain tablet: Cleanlist is
 * desktop-only and the app shell blocks touch-only screens (MobileBlocker).
 * Replay: sign-ups from the free tools on phones made an account and only
 * then hit "Open Cleanlist on Desktop". Same test as the blocker
 * (``TOUCH_ONLY_QUERY``). Sign-up stays available.
 */
export function DesktopOnlyNotice() {
  const [touchOnly] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(TOUCH_ONLY_QUERY).matches
  );
  if (!touchOnly) return null;

  return (
    <div
      role='note'
      className='mb-4 flex items-start gap-3 rounded-lg border border-border bg-muted/40 p-3 text-left'
    >
      <AppIcon
        icon={iconDesktop}
        className='mt-0.5 h-4 w-4 shrink-0 text-muted-foreground'
      />
      <div className='text-xs text-muted-foreground'>
        <p className='font-medium text-foreground'>
          {BRAND.name} works on a computer
        </p>
        <p className='mt-0.5'>
          You can create your account here, but you&apos;ll need a desktop
          browser to use it.
        </p>
      </div>
    </div>
  );
}
